import {
	createSlice,
	current
} from '@reduxjs/toolkit';
import {
	getManagementTeamList,
	addNewManagementTeam,
	updateManagementTeam,
	deleteManagementTeam,
	getManagementTeam,
} from '../managementTeam/thunk';

export const initialState = {
	itemManagementTeamList: [],
	itemManagementTeamDetail: null,
	isManagementTeamLoading: false,
	isManagementTeamSuccess: false,

	managementTeamList: [],
	managementTeamListSelect: [],
	isLoadingList: false,
	isAdding: false,
	isAdded: false,
	isAddError: false,
	isUpdating: false,
	isUpdated: false,
	isUpdateError: false,
	isDeleting: false,
	isDeleted: false,
	isDeleteError: false,
	requireCloseModal: false,
};

const ManagementTeamSlice = createSlice({
	name: 'ManagementTeams',
	initialState,
	reducers: {
		setRequireCloseModal(state, action) {
			state.requireCloseModal = action.payload;
		},
	},
	extraReducers: builder => {
		builder.addCase(getManagementTeam.fulfilled, (state, action) => {
			state.isManagementTeamLoading = false;
			state.isManagementTeamSuccess = true;
			state.itemManagementTeamDetail = action.payload;
			state.isLoadingList = false;
		});
		builder.addCase(getManagementTeam.pending, state => {
			state.isManagementTeamLoading = true;
			state.isManagementTeamSuccess = null;
			state.error = null;
			state.isLoadingList = true;
		});
		builder.addCase(getManagementTeam.rejected, (state, action) => {
			state.isManagementTeamLoading = false;
			state.isManagementTeamSuccess = false;
			state.error = action.error.message;
			state.isLoadingList = false;
		});

		builder.addCase(getManagementTeamList.pending, state => {
			state.isManagementTeamSuccess = true;
			state.error = null;
			state.isLoadingList = true;
		});
		builder.addCase(getManagementTeamList.fulfilled, (state, action) => {
			state.itemManagementTeamList = action.payload;
			state.managementTeamList = action.payload;
			state.isLoadingList = false;
			state.isManagementTeamSuccess = true;

			let managementTeamListSelect = [];
			action.payload.map(item =>
				managementTeamListSelect.push({
					item: item,
					value: item._id,
					label: item.person.full_name,
				})
			);
			
			console.log('___:',managementTeamListSelect)

			state.managementTeamListSelect = managementTeamListSelect;
		});
		builder.addCase(getManagementTeamList.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isManagementTeamSuccess = true;
		});
		builder.addCase(addNewManagementTeam.fulfilled, (state, action) => {
			state.itemManagementTeamList.push(action.payload);
			state.managementTeamList.push(action.payload);
			state.isLoadingList = false;
			state.isAdding = false;
			state.isAdded = true;
			state.isAddError = false;
			state.requireCloseModal = true;
		});
		builder.addCase(addNewManagementTeam.pending, (state, action) => {
			state.isLoadingList = true;
			state.isAdding = true;
			state.isAdded = false;
			state.isAddError = false;
		});
		builder.addCase(addNewManagementTeam.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isAdding = false;
			state.isAdded = false;
			state.isAddError = true;
		});

		builder.addCase(updateManagementTeam.fulfilled, (state, action) => {
			state.itemManagementTeamList = state.itemManagementTeamList.map(managementTeam =>
				managementTeam.managementTeamname === action.payload.old_managementTeam
					? { ...managementTeam, ...action.payload.updated_managementTeam }
					: managementTeam
			);
			state.managementTeamList = state.managementTeamList.map(managementTeam =>
				managementTeam._id.toString() === action.payload._id.toString()
					? { ...managementTeam, ...action.payload }
					: managementTeam
			);
			state.isLoadingList = false;
			state.isUpdating = false;
			state.isUpdated = true;
			state.isUpdateError = false;
			state.requireCloseModal = true;
		});
		builder.addCase(updateManagementTeam.pending, state => {
			state.isLoadingList = true;
			state.isUpdating = true;
			state.isUpdated = false;
			state.isUpdateError = false;
		});
		builder.addCase(updateManagementTeam.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isUpdating = false;
			state.isUpdated = false;
			state.isUpdateError = true;
		});

		builder.addCase(deleteManagementTeam.fulfilled, (state, action) => {
			state.itemManagementTeamList = current(state.itemManagementTeamList).filter(
				item => item._id !== action.payload._id
			);
			state.managementTeamList = current(state.managementTeamList).filter(item =>
				item._id !== action.payload._id
			);
			state.isLoadingList = false;
			state.isDeleting = false;
			state.isDeleted = true;
			state.isDelete = false;
			state.requireCloseModal = true;
		});
		builder.addCase(deleteManagementTeam.pending, (state, action) => {
			state.isLoadingList = true;
			state.isDeleting = false;
			state.isDeleted = true;
			state.isDelete = false;
		});
		builder.addCase(deleteManagementTeam.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isDeleting = false;
			state.isDeleted = false;
			state.isDelete = true;
		});
	},
});

export const { setRequireCloseModal } = ManagementTeamSlice.actions;

export default ManagementTeamSlice.reducer;
